// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"91":"person-record","127":"company-record","152":"eula","387":"project-record"}[chunkId] + "." + {"91":"4a2dd2be586880adda64","127":"dcb2facb2fc6a7c388cc","152":"8dbad287d105e4dee3fe","387":"e69de58019b531eaeb77"}[chunkId] + ".css";
};